import { PRODUCT_ROUTES } from './route-names'

// TODO: Use ProductResponse type to get the obsolete drawer types
export const OBSOLETE_DRAWER_TYPES = {
  [PRODUCT_ROUTES.WEBVIEWS_OBSOLETE_SOFTWARE_DRAWER]: 'software_obsolete',
}
